import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { Steps } from 'antd';

const Step = Steps.Step;

const Instructions = {
    validOrganization: {
        title: 'Confirm the POI has been assigned to the correct Organisation',
        description: '',
        steps: [
            {
                name: 'Check that the POI belongs to the listed organisation.',
                example: (<div><b>Correct Example: </b>The POI ‘BP Bondi Road’ belongs to the organisation ‘BP’ <br/>
                    <b>Incorrect Example: </b>The POI ‘NZ 100% Ltd’ does not belong to organisation ‘100% Electrical’</div>),
            },
            {
                name: 'Check for any labels on the map that confirm the POI belongs to the organisation.',
                example: `There is a label on the map that shows a 'fuel pump' indicating petrol station`,
            },
            {
                name: 'Check if the building shape and key POI features on the map confirm the POI belongs to the organisation',
                example: 'There is a clear forecourt and store positioned in a way that differentiates a petrol station',
            },
            {
                name: `If there is still some ambiguity at this point then you can identify the organisation logo online and use street view to confirm that there is a match in branding with the POI's main business logo.`,
                example: '',
            },
        ],
        scenarios: [
            {
                name: `The POI doesn’t belong to the organisation`,
                action: `Select ‘Incorrect’`,
            },
            {
                name: `It’s not possible to confirm`,
                action: `Select ‘Unsure’`,
            },
            {
                name: `The POI belongs to the organisation`,
                action: `Select ‘Correct’`,
            },
        ]
    },
    fixPOICenter: {
        title: 'Confirm the map pin is correctly placed on the POI',
        description: (<div style={{marginBottom: 5, marginTop: 5 }}><b>Larger Building: </b>a building that contains multiple POIs<br/><br/>
            <b>POI Building: </b>a building that contains a single POI, or a distinguishable section of a larger Building that the POI occupies</div>),
        steps: [
            {
                name: `Identify the physical location of the POI on the map`,
                example: ``,
            },
            {
                name: ` If it is possible to identify the POI Building then move the red pin to the centre.`,
                example: ``,
            },
            {
                name: ` If it is not possible to identify the POI Building then move the red pin to the centre of the Larger Building.`,
                example: ``,
            },
            {
                name: ` If the POI doesn’t have a building then place the red pin at the centre of the POI`,
                example: ``,
            },
        ],
        scenarios: [
            {
                name: 'The POI name or address is labelled on the map, in close proximity to the pin.',
                action: `Move the pin and select ‘Correct’.`,
            },
            {
                name: 'There are buildings in close proximity to the pin but none are labelled.',
                action: `Use Google Street View to confirm if one is the POI. If identified move the pin and select ‘Correct’.`,
            },
            {
                name: `None of the buildings on the map are the POI`,
                action: `Spend a few minutes moving around the map to see if the POI can be identified. If identified move the pin and select ‘Correct’.`,
            },
            {
                name: `It’s not been possible to identify the POI.`,
                action: `Select ‘Unsure’`,
            },
        ]
    },
    fixOnPremise: {
        title: 'Confirm the ‘On Premise’ geofence is correctly drawn',
        description: (<p>‘On Premise’ includes all of the land that the POI occupies. This includes all buildings that belong to the POI, any land surrounding these buildings and any parking areas. Shared land and parking areas should be included. Public roads, train lines and buildings that are not part of the POI will generally create the boundary around the land that a POI occupies. Fences, walls or lines of trees are also a good indication of the “On Premise’ boundary.</p>),
        steps: [
            {
                name: `If the geofence only requires a minor change them use the edit function to correct it.`,
                example: ``,
            },
            {
                name: `If the geofence requires a major change then use the redraw function to correct it.`,
                example: ``,
            },
        ],
        scenarios: [
            {
                name: `No geofence is shown but it is possible to identify the land that this POI occupies.`,
                action: `Draw the geofence around the land and select ‘Correct’`,
            },
            {
                name: `No geofence is shown and it is not possible to identify the land that this POI occupies.`,
                action: `Select ‘Unsure’`,
            },
            {
                name: `The geofence includes all of the land that this POI occupies.`,
                action: `Geofence is ‘Correct’`,
            },
            {
                name: `The geofence doesn't includes all of the land that this POI occupies.`,
                action: `Edit the geofence to include all the occupied land and select ‘Correct’`,
            },
            {
                name: `The geofence includes land beyond that which this POI occupies.`,
                action: `Edit the geofence to include only the occupied land and select ‘Correct’`,
            },
            {
                name: `The POI is inside another building and the geofence is the building shape.`,
                action: `Select ‘Correct’`,
            },
            {
                name: `The POI is inside another building and the geofence is not the building shape.`,
                action: `Redraw the geofence around the building shape and select ‘Correct’`,
            },
            {
                name: `The geofence includes all of the land that this POI occupies but also includes other POIs and all of the land which they occupy. There are no clear boundaries for this POI.`,
                action: `Geofence is ‘Correct’`,
            },
            {
                name: `The geofence includes multiple POIs but doesn’t includes all of the land they occupy. There are no clear boundaries for this POI.`,
                action: `Edit the geofence to include all the occupied land and select ‘Correct’`,
            },
            {
                name: `The geofence includes multiple POIs but includes land beyond which they occupy. There are no clear boundaries for this POI.`,
                action: `Edit the geofence to include only the occupied land and select ‘Correct’`,
            },
            {
                name: `The geofence includes multiple POIs but there are obvious boundaries which make it possible to identify the land that this POI occupies.`,
                action: `Redraw the geofence around the land and select ‘Correct’`,
            },
            {
                name: `A geofence is shown but it's not possible to identify the land that this POI occupies`,
                action: `Select ‘Unsure’`,
            }
        ]
    }
}

class ValidationInstructionsSidebar extends Component {
    render() {
        const validationStage = this.props.validationStage;
        
        const generateInstructions = (stage) => {
            const instructions = Instructions[stage];
            if (!_.isUndefined(instructions)){
                return(
                    <div style={{ paddingTop: 10 }} className="list">
                        <h4 className="heading-level-1" style={{
                            marginBottom: 16,
                        }}>{instructions.title}</h4>
                        <div style={{ marginBottom: 20 }}>
                            <h4 className="heading-level-2">Definitions</h4>
                            {instructions.description ? (
                                <div>{instructions.description}</div>
                            ): null}
                        </div>
                        {instructions.steps.length > 0 ? (
                            <div>
                                <h4 className="heading-level-2">Instructions</h4>
                                <Steps direction="vertical" size="large" progressDot>
                                    {instructions.steps.map((step, i) => (
                                        <Step title={step.name} description={step.example} key={i} status="finish" />
                                    ))}

                                </Steps>
                            </div>
                        ): null}
                        {instructions.scenarios.length > 0 ? (
                            <div style={{ marginTop: 20 }}>
                                <h4 className="heading-level-2">Scenarios</h4>
                                <ul className="horizontal-list">
                                    {instructions.scenarios.map((scenario, i) => (
                                        <li key={i}>
                                            <b>{scenario.name}</b>
                                            <p>{scenario.action}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ): null}
                        
                    </div>
                )
            }
        }

        return (
            <div>
                <div className="sidebar-inner">
                    {generateInstructions(validationStage)}
                </div>
            </div>
        );
    }
}

ValidationInstructionsSidebar.propTypes = {
    validationStage: PropTypes.oneOf(['validOrganization', 'fixPOICenter', 'fixOnPremise']),
    match: PropTypes.shape({
        params: PropTypes.shape({
            'poi_id': PropTypes.string,
        }),
    }),
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const ValidationInstructionsSidebarContainer = connect(mapStateToProps,mapDispatchToProps)(ValidationInstructionsSidebar);
export default ValidationInstructionsSidebarContainer;



// WEBPACK FOOTER //
// ./src/validation/components/ValidationInstructionsSidebar.js